export default __webpack_public_path__ + "static/img-perk-3-4638eb071b1fbbda1df67a208d4562eb.png";